import React, { useState } from 'react';
import { authFetch } from '../../Utilities/Api';
import './NewPost.css';

const NewPost = ({ onPostCreated }) => {
    const [text, setText] = useState('');
    const [images, setImages] = useState([]);
    // 1. ADD NEW STATE for visibility, default to 'friends-only' 
    //    to match your Mongoose schema default.
    const [visibility, setVisibility] = useState('friends-only');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        setImages(files);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!text.trim() && images.length === 0) {
            setError('Post must have text or at least one image.');
            return;
        }

        // Note: Your backend expects 'text' and 'visibility' directly in the body,
        // but it appears you are uploading images which often requires FormData.
        // We need to ensure the backend can handle both fields from FormData.
        // Assuming your backend handles files and text fields correctly from FormData:

        const formData = new FormData();

        // 2. APPEND VISIBILITY to FormData
        formData.append('visibility', visibility);

        formData.append('text', text.trim()); // Changed 'content' to 'text' to match your backend route expected body property
        images.forEach(image => {
            formData.append('images', image); // Changed 'image' to 'images' to match common array upload field names
        });

        setLoading(true);
        try {
            // Note: If your backend expects a specific path like '/profile-posts/create', adjust the URL here.
            const res = await authFetch('/profile-posts/create', { // Assumed '/create' suffix
                method: 'POST',
                // When using FormData, do NOT set Content-Type header; fetch sets it automatically
                body: formData,
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data?.message || 'Something went wrong.');
            }

            onPostCreated(data);
            setText('');
            setImages([]);
            // Reset visibility to default after successful post
            setVisibility('friends-only');
        } catch (err) {
            console.error('❌ Failed to create post:', err);
            setError(err.message || 'Unexpected error.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className="new-post" onSubmit={handleSubmit}>
            {error && <p className="error-text">{error}</p>}

            <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="What's on your mind?"
                rows={3}
            />

            {images.length > 0 && (
                <div className="image-preview-container">
                    {images.map((img, idx) => (
                        <img
                            key={idx}
                            src={URL.createObjectURL(img)}
                            alt={`preview-${idx}`}
                            className="image-preview"
                        />
                    ))}
                </div>
            )}

            <div className="new-post-actions">
                <label className="file-input-label">
                    📷 Add Images
                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleImageChange}
                        style={{ display: 'none' }}
                    />
                </label>

                {/* 3. ADD THE VISIBILITY DROPDOWN/SELECTOR */}
                <select
                    value={visibility}
                    onChange={(e) => setVisibility(e.target.value)}
                    className="post-visibility-select"
                >
                    <option value="friends-only">Friends Only 🤝</option>
                    <option value="public">Public 🌐</option>
                    <option value="private">Private (Only Me) 🔒</option>
                </select>

                <button type="submit" disabled={loading}>
                    {loading ? 'Posting...' : 'Post'}
                </button>
            </div>
        </form>
    );
};

export default NewPost;